<template>
    <van-popup v-model="SignShow" class="sign_bg" style="background: none;">
        <img class="background-img" src="@/assets/sign_background.png" mode="width" />

        <div class="content">
            <div class="main">
                <span class="title">{{ current_continuous_days > 0 ? $t('signIn.txt2') : $t('signIn.txt1') }}</span>
                <span class="total">{{ $t('signIn.txt3') }} {{ current_continuous_days }} {{ $t('signIn.txt4') }}</span>
                <span class="scores">{{ $t('signIn.txt6') }}:{{ point }}</span>
            </div>
            <div>
                <div class="days-box">
                    <div class="days" v-for="(item, index) in weekdays" :key="index">
                        <!-- <uni-icons v-if="signInRes.days.includes(item - 1)" class="icon active" color="#FFFFFF"
                            type="checkmarkempty"></uni-icons> -->
                        <van-icon name="success" v-if="current_continuous_days > index" class="icon active" color="#FFFFFF" />
                        <template v-else>
                            <van-icon v-if="item < current_continuous_days" class="icon active" color="#FFFFFF" name="cross" />
                            <van-icon v-else name="success" class="icon" color="#FFFFFF" />
                        </template>
                        <template>
                            <span class="day" :class="{ grey: item > current_continuous_days }">{{ weekdaysPoint[item - 1]
                                }}{{ $t('signIn.txt9') }}</span>
                        </template>

                        <!-- <span v-else class="day">缺卡</span> -->
                    </div>
                </div>
                <van-button class="signIn_btn" :class="signedToday?'active':''" type="primary" size="normal" @click="SignInClick()">{{ $t('signIn.txt10') }}</van-button>
                <!-- <div class="tip-box">
                    <span class="tip">{{ $t('signIn.txt7') }}10{{ $t('signIn.txt9') }}</span>
                    <div class="row">
                        <span class="tip">{{ $t('signIn.txt8') }}</span>
                        <span class="red">50</span>
                        <span class="tip">{{ $t('signIn.txt9') }}</span>
                    </div>
                </div> -->
            </div>
            <van-icon @click="closeMe" class="close-icon" size="30" color="#ffffff" name="close" />
        </div>
    </van-popup>
</template>


<script>
import { Toast } from 'vant';
// const date = new Date(new Date().toLocaleDateString()).getTime()
export default {
    name: "signIn",

    // props: {
    //     current_continuous_days: {
    //         type: [String, Number],
    //         default() {
    //             return 0
    //         }
    //     },
    //     point: {
    //         type: [String, Number],
    //         default() {
    //             return 0
    //         }
    //     }
    // },
    data() {
        return {
            total: 0,
            scores: 0,
            weekdays: [1, 2, 3, 4, 5, 6, 7],
            weekdaysPoint: [1, 2, 3, 5, 10, 20, 35],
            signInRes: {
                days: [],
                n: 0
            },
            SignShow: false,
            
            current_continuous_days:0,
            point: 0,
            signedToday: false,
            sign_status: 0,
            recharge_total: 0
        }
    },
    mounted() {

        this.$http({
            method: 'get',
            url: 'user_info'
        }).then(ret => {
            if (ret.code === 200) {

                this.signedToday = ret.data.signedToday
                this.sign_status = ret.data.sign_status
                this.recharge_total = ret.data.recharge_total
                this.current_continuous_days = ret.data.current_continuous_days
                this.point = ret.data.point
            } else if (ret.code === 401) {

                this.$toast(ret.msg);
            }
        })
    },
    methods: {

        SignInClick() {
            if (this.signedToday) {
                return this.$toast('Selamat anda telah berhasil check in hari ini. hanya dengan melakukan check in setiap hari akan mendapatkan lebih banyak poin reward.');
            }

            if (this.sign_status == 0) {
                return this.$toast('Setelah menyelesaikan tugas 8 akan otomatis mangaktifkan check-in dan dapat mengahsilkan poin untuk di tukarkan dengan hadiah menarik.');
            }
            Toast.loading({
                forbidClick: true,
            });

            this.$http({
                method: 'get',
                url: 'userSign'
            }).then(res => {

                if (res.code === 200) {
                    this.$http({
                        method: 'get',
                        url: 'user_info'
                    }).then(ret => {
                        if (ret.code === 200) {

                            this.signedToday = ret.data.signedToday
                            this.sign_status = ret.data.sign_status
                            this.recharge_total = ret.data.recharge_total
                            this.current_continuous_days = ret.data.current_continuous_days
                            this.point = ret.data.point
                            Toast.clear();
                            this.$toast('Selamat anda telah berhasil check in hari ini. hanya dengan melakukan check in setiap hari akan mendapatkan lebih banyak poin reward.');
                            // this.$refs.SignIn.open()
                        } else if (ret.code === 401) {

                            Toast.clear();
                            this.$toast(ret.msg);
                        }
                    })
                } else {
                    Toast.clear();
                    this.$toast(res.msg);
                }
            })

        },
        //普通点击签到
        async open() {
            this.SignShow = true
            // try {
            // 	let res = await this.getSignedInInfo();
            // 	if (res && res.length == 0) {
            // 		let res = await signInTable.add({});
            // 		console.log(res);
            // 		Toast.clear();
            // 		this.signInRes = res.result
            // 		this.SignShow = true
            // 		if (this.signInRes.days.length == 7) {
            //             Toast('你已完成7日连续签到，获得60积分！');
            // 		} else {
            //             Toast('签到成功,获得10积分！');
            // 		}
            // 	}
            // } catch (e) {
            // 	Toast.clear();
            // 	console.error(e)
            // }
        },
        closeMe() {
            this.SignShow = false
        }
    }
}
</script>



<style lang="scss" scoped>
.sign_bg {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
    }

    .background-img {
        width: 600px;
        height: 600px;
    }

    .content {
        position: absolute;
        width: 600px;
        height: 600px;
        justify-content: space-around;
        align-items: center;
        border-radius: 10px;
        z-index: 5;
    }

    .background-img,
    .content {
        // top: 0;
    }

    .main {
        align-items: center;
    }

    .title {
        font-size: 44px;
        color: #FFFFFF;
        font-weight: 600;
    }

    .total {
        background-color: #FFFFFF;
        color: #ed5200;
        text-align: center;
        border-radius: 100px;
        font-size: 26px;
        margin: 16px 0;
        padding: 8px 10px;
        // width: 230px;
    }

    .scores {
        text-align: center;
        color: #FFFFFF;
    }

    .days-box {
        flex-direction: row;
    }

    .days {
        margin: 12px;
        font-size: 19px;
        justify-content: center;
        align-items: center;
        color: #f8692c;
    }

    .grey {
        color: #C0C0C0;
    }

    .days-box .icon {
        background-color: #feefeb;
        border-radius: 100px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        width: 50px;
        margin-bottom: 6px;
    }

    .days-box .icon.active {
        background-image: linear-gradient(to top, #FF9002, #FF5100);
        background-color: #ffff7f;
    }

    .content,
    .days-box {
        padding: 26px;
    }

    .tip-box {
        justify-content: center;
    }

    .tip-box .row {
        flex-direction: row;
        justify-content: center;
    }

    .tip,
    .red {
        text-align: center;
        font-size: 24px;
        color: #999999;
        height: 30px;
        line-height: 30px;
    }

    .red {
        color: #ff0000;
    }

    .close-icon {
        margin-bottom: -180px;
        border-radius: 100px;
        text-align: center;
        height: 46px;
        line-height: 46px;
        width: 46px;
    }
    .signIn_btn{
        margin: 30px 20px;
        height: 80px;
        line-height: 80px;
        border-radius: 50px;
        color: #fff;
        font-size: 40px;
        font-weight: bolder;
        border: none;
        background:linear-gradient(90deg, #FF9002, #FF5100);
    }
    .signIn_btn.active{
        background:#a6a6a6;
    }
}
</style>